import { useModal } from '@ebay/nice-modal-react'
import { useNavigate } from '@tanstack/router'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { Portal } from 'react-portal'

import kycBonusIcon from '../../assets/common/kyc_bonus_icon.webp'
import vortex from '../../assets/common/vortex.webp'
import useKycInfo from '../../hooks/useKycInfo'
import type { ApiResponse } from '../../types/api'
import { api } from '../../utils/api-client'
import Icon from '../icon'
import { ToastMessage } from '.'

const KycBonus = () => {
  const navigate = useNavigate()
  const { isVerifiedBadge } = useKycInfo()
  const toastMessage = useModal(ToastMessage)
  const [show, setShow] = useState(false)

  const getHideBonus = () => {
    try {
      const hideBonus = localStorage.getItem('hideBonus')
      if (!hideBonus) return false
      if (dayjs().diff(dayjs(hideBonus), 'days') > 1) return false
      return true
    } catch (error) {
      console.error(error)
      return false
    }
  }

  useEffect(() => {
    const hideBonus = getHideBonus()

    if (hideBonus) {
      setShow(false)
      return
    }

    const checkBonus = async () => {
      try {
        const res = await api.post<ApiResponse<string>>('/conduct.php', {
          type: 'is_show_gratis',
        })
        const { status } = res.data
        if (status === 1) {
          setShow(true)
        }
      } catch (error) {
        console.error(error)
      }
    }

    checkBonus()
  }, [])

  const claim = async () => {
    if (isVerifiedBadge !== 1) {
      navigate({ to: '/profile/kyc' })
      return
    }
    try {
      const res = await api.post<ApiResponse<string>>('/conduct.php', {
        type: 'apply_gratis',
      })
      const { status, info } = res.data
      toastMessage.show({
        text: info,
        isValid: status === 1,
      })
      if (status === 1) {
        setShow(false)
      }
    } catch (error) {
      console.error(error)
    }
  }

  if (!show || isVerifiedBadge === 1) return null

  return (
    <Portal>
      <div className="fixed z-10 left-5 bottom-[200px] xl:left-[100px]">
        <button
          className="flx-ctr absolute right-[-5px] z-[1] w-[25px] h-[25px] bg-[rgba(0,0,0,0.4)] cursor-pointer rounded-[50%] xl:w-[35px] xl:h-[35px]"
          onClick={e => {
            e.stopPropagation()
            localStorage.setItem('hideBonus', dayjs().toString())
            setShow(false)
          }}>
          <Icon
            className="fill-white w-[11px] h-[11px] xl:w-[15px] xl:h-[15px]"
            id="close"
          />
        </button>
        <img
          className="w-[120px] animate-pop cursor-pointer xl:w-[200px]"
          src={kycBonusIcon}
          alt="50 Gratis"
          onClick={claim}
        />
        <img
          className="absolute top-0 left-0 w-full aspect-[1] animate-rotate-6 pointer-events-none z-[-1]"
          src={vortex}
          alt="Vortex"
        />
      </div>
    </Portal>
  )
}

export default KycBonus
